import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ProjectEVMPage from "@/pages/admin/ProjectEVMPage";

export const Route = createFileRoute("/_admin/admin/project-evm")({
  head: () => pageHead("Admin · Project Evm", "AKIVA admin · project evm portal.", "/admin/project-evm", true),
  component: ProjectEVMPage,
});
